import { render, staticRenderFns } from "./PatientsLiveSearch.vue?vue&type=template&id=0f9a474c&scoped=true&"
import script from "./PatientsLiveSearch.vue?vue&type=script&lang=js&"
export * from "./PatientsLiveSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a474c",
  null
  
)

export default component.exports